/*
Based on API documentation here: https://developers.stamped.io/#7d02c323-794e-443f-9512-28373a244854
*/

if (!customElements.get('pdp-stamped-reviews')) {
  const chevron = `
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Group 34" width="100%" height="100%" viewBox="0 0 11.506 20.803">
      <defs>
          <clipPath id="9fubhk7wpa">
              <path data-name="Rectangle 17" style="fill: currentColor;" d="M0 0h11.506v20.803H0z"/>
          </clipPath>
      </defs>
      <g data-name="Group 21" style="clip-path:url(#9fubhk7wpa)">
          <path data-name="Path 15" d="m1.562 20.8 9.621-9.621a1.1 1.1 0 0 0 0-1.562L1.562 0 0 1.562 8.84 10.4 0 19.242z" style="fill:currentColor;"/>
      </g>
    </svg>
  `;
  
  customElements.define(
    'pdp-stamped-reviews',
    class PDPStampedReviews extends HTMLElement {
      constructor() {
        super();
        this.appliedFilters = [''];
        this.productId = null;
        this.publicKey = `pubkey-zEDQR2k981Y8nkm0PV1W27cjEc6l6Q`;
        this.sectionId = null;
        this.storeUrl = `www.legends.com`;
        this.tags = null;
        this.enableFilter = false;
      }
    
      connectedCallback() {
        this.addEventListener('click', e => {
          const filterButton = e.target.closest('[data-action="filter"]');
          if (!filterButton) return;
          const tag = filterButton.dataset.tag;
          
          if (this.appliedFilters.find((filter) => filter === tag)) {
            const indexToRemove = this.appliedFilters.indexOf(tag);
            this.appliedFilters.splice(indexToRemove, 1);
            filterButton.classList.remove('active');
          } else {
            this.appliedFilters.push(tag);
            filterButton.classList.add('active');
          }
          
          this.getReviews();
        });
        
        document.addEventListener('DOMContentLoaded', () => {
          this.productId = this.dataset.productId;
          this.sectionId = this.dataset.sectionId;
          this.tags = this.dataset.tags?.replace(/ /g,'').split(',');
          this.getReviews();
        });
      }
      
      async getReviews() {
        await fetch(`http://stamped.io/api/widget/reviews?minRating=1&productId=${this.productId}&take=100&storeUrl=${this.storeUrl}&apiKey=${this.publicKey}&tags=${this.appliedFilters}`)
            .then((response) => response.json())
            .then((json) => {
              if (!json.data.length) {
                return;
              }
              
              this.innerHTML = '';
              this.generateSliderMarkup(json.data);
              
            })
            .catch((err) => {
              console.error(`Unable to load the custom Stamped widget.`, err);
              this.closest('.shopify-section').classList.add('hidden');
            });
      }
      
      generateSliderMarkup(reviews) {
        this.innerHTML = `
          <div class="z-[1] flex flex-col relative">
            <div class="gap-5 flex flex-col md:hidden">
              ${reviews.slice(0, 3).map((review) => `
                <div class="bg-secondaryLight py-11 px-10 lg:py-14 lg:px-11 flex flex-col gap-5 h-full">
                  <div class="flex items-center justify-between">
                    <span class="flex items-center">
                      ${[...Array.from(Array(Math.round(review.reviewRating)).keys())]
                          .map(() => `<i class="stamped-fa stamped-fa-star block w-4 h-4" style="color:#c3baa3 !important;" aria-hidden="true"></i>`)
                          .join('') }
                      ${[...Array.from(Array(Math.round(5 - review.reviewRating)).keys())]
                          .map(() => `<i class="stamped-fa stamped-fa-star-o block w-4 h-4" style="color:#c3baa3 !important;" aria-hidden="true"></i>`)
                          .join('')}
                    </span>
                    <span class="text-xs">${new Date(review.dateCreated). toLocaleDateString()}</span>
                  </div>
                  <strong>${review.reviewTitle}</strong>
                  <p>${review.reviewMessage}</p>
                  <div class="flex flex-col text-xs mt-auto">
                    <strong>${review.author}</strong>
                    <span>${review.reviewVerifiedType === 2 ? 'Verified Buyer' : ''}</span>
                  </div>
                </div>
              `).join('')}
            </div>
            <div class="container px-0 overflow-hidden hidden md:block">
              <swiper-carousel
                data-space-between="55"
                data-centered="true"
                data-slides-per-view="3"
                class="block w-full max-md:hidden"
                data-external-nav-buttons="section-${this.sectionId}"
              >
                <div class="swiper-wrapper items-stretch [&_.swiper-slide]:!h-auto">
                  ${reviews.map((review) => `
                    <div class="swiper-slide">
                      <div class="bg-secondaryLight py-11 px-10 lg:py-14 lg:px-11 flex flex-col gap-5 h-full">
                        <div class="flex items-center justify-between">
                          <span class="flex items-center">
                            ${[...Array.from(Array(Math.round(review.reviewRating)).keys())]
                                .map(() => `<i class="stamped-fa stamped-fa-star block w-4 h-4" style="color:#c3baa3 !important;" aria-hidden="true"></i>`)
                                .join('') }
                            ${[...Array.from(Array(Math.round(5 - review.reviewRating)).keys())]
                                .map(() => `<i class="stamped-fa stamped-fa-star-o block w-4 h-4" style="color:#c3baa3 !important;" aria-hidden="true"></i>`)
                                .join('')}
                          </span>
                          <span class="text-xs">${new Date(review.dateCreated).toLocaleDateString()}</span>
                        </div>
                        <strong>${review.reviewTitle}</strong>
                        <p class="block max-h-[200px] overflow-auto">${review.reviewMessage}</p>
                        <div class="flex flex-col text-xs mt-auto">
                          <strong>${review.author}</strong>
                          <span>${review.reviewVerifiedType === 2 ? 'Verified Buyer' : ''}</span>
                        </div>
                      </div>
                    </div>
                  `).join('')}
                </div>
              </swiper-carousel>
            </div>
            <button data-prev="section-${this.sectionId}" aria-label="Previous Slide" title="Previous Slide" class="button-slider disabled:opacity-100 disabled:bg-[#f5f5f4] disabled:text-silverSand shadow absolute top-1/2 -left-8 z-10 hidden md:flex">
              <span aria-hidden="true" class="block h-4 transform -scale-x-100 w-3">
                ${chevron}
              </span>
            </button>
            <button data-next="section-${this.sectionId}" aria-label="Next Slide" title="Next Slide" class="button-slider disabled:opacity-100 disabled:bg-[#f5f5f4] disabled:text-silverSand shadow absolute top-1/2 -right-8 z-10 hidden md:flex">
              <span aria-hidden="true" class="block h-4 w-3">
                ${chevron}
              </span>
            </button>
          </div>
          <div>
            ${this.tags.length && this.enableFilter ?   `
              <div class="flex flex-col container md:max-w-2xl gap-8 text-center pt-11">
                <span>Filter Reviews</span>
                <div class="flex flex-wrap gap-3 justify-center items-center">
                  ${this.tags.map((tag) => `
                    <button 
                      class="[&.active]:border-current border border-transparent bg-secondaryLight py-2 px-5 ${this.appliedFilters.find((filter) => filter === tag) ? 'active' : '' }" 
                      type="button" 
                      data-action="filter"
                      data-tag="${tag}"
                    >
                      ${tag}
                    </button>
                  `).join('')}
                </div>
              </div>
            ` : ''}
          </div>
        `;
      }
    }
  );
}